<template>
    <transition name="notification">
        <div class="notification" :class="[{confirm}, type]">
            <p class="message">
                {{message}}
            </p>
            <button class="confirm default-element-size" v-if="confirm" @click="destroy">Хорошо</button>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "notification",
        props:{
            message:{
                type: String,
                required: true,
            },
            confirm: {
                type: Boolean,
                required: false,
            },
            type: {
                type: String,
                required: false,
                default: 'default'
            }
        },
        mounted(){
            if(!this.confirm){
                setTimeout(()=>{
                   this.destroy();
                }, 2000)
            }
        },
        methods:{
            destroy(){
                this.$emit('destroy');
            }
        }
    }
</script>

<style scoped lang="scss">
    .notification{
        position: fixed;
        bottom: 0;
        left: calc(50% - 944px / 2);
        width: 944px;

        display: flex;
        align-items: center;
        justify-content: center;

        height: 80px;
        padding: 0 96px;
        border-radius: 32px 32px 0 0;

        &.default {
            background-color: $blue;
        }
        &.warn {
            background-color: $orange;
        }
        &.error {
            background-color: $red;
        }

        &.confirm{
            justify-content: space-between;
        }
        *{
            font-weight: bold;
            color: white;
        }
        .message{
            font-weight: bold;
            font-size: 20px;
            line-height: 25px;
        }
        button.confirm{
            background: rgba(255, 255, 255, 0.12);
            font-size: 16px;
            line-height: 19px;
            width: 203px;

        }

        @include laptop{
            left: 0;
            right: 0;
            width: 100%;
        }
        @include mobile{
            flex-direction: column;
            padding: 16px 24px;
            height: auto;
            .message{
                font-size: 18px;
                line-height: 22px;
            }
            button{
                margin-top: 32px;
            }
        }
    }
    .notification-enter-active, .notification-leave-active {
        transition: transform $transition;
    }
    .notification-enter, .notification-leave-to {
        transform: translateY(100%);
    }
</style>